export const LAST_UPDATED_LABEL = '03/04/2026';

export const legalDocuments = {
  clientTerms: {
    audience: 'Cliente',
    category: 'Termos de Uso',
    title: 'Cliente - Termos de Uso',
    description: 'Condições de uso da plataforma para clientes finais.',
    path: '/termos-de-uso/cliente',
    html: `
      <h2>Termos e Condições de Uso da Plataforma Clicklav</h2>
      <p><strong>Cliente Final</strong></p>
      <h3>1. ACEITAÇÃO E OBJETO DA PLATAFORMA</h3>
      <ul>
        <li>Ao acessar ou utilizar a plataforma ClickLav, o cliente declara ter lido, compreendido e concordado integralmente com estes Termos de Uso.</li>
        <li>A ClickLav é uma plataforma digital que intermedeia a conexão entre clientes e prestadores independentes de serviços de estética automotiva.</li>
        <li>Os serviços intermediados incluem lavagem ecológica, detalhamento e serviços correlatos.</li>
        <li>A ClickLav atua exclusivamente como intermediadora tecnológica e não executa diretamente quaisquer serviços.</li>
      </ul>
      <h3>2. NATUREZA DA RELAÇÃO COM O PRESTADOR</h3>
      <ul>
        <li>A contratação do serviço ocorre diretamente entre o cliente e o prestador independente, também denominado Clicker, Detailer ou Ecolavador.</li>
        <li>A ClickLav não executa os serviços automotivos, não supervisiona a sua execução e não possui ingerência técnica sobre o trabalho realizado.</li>
      </ul>
      <h3>3. RESPONSABILIDADE PELOS SERVIÇOS E DANOS</h3>
      <ul>
        <li>O prestador é o único responsável pela execução do serviço, pela qualidade técnica do resultado e pelos equipamentos utilizados durante o atendimento.</li>
        <li>Qualquer eventual dano causado ao veículo do cliente ou a terceiros durante a execução do serviço é de inteira responsabilidade do prestador.</li>
        <li>A ClickLav não se responsabiliza por danos decorrentes da execução do serviço, pela qualidade do serviço prestado, nem por eventuais atrasos ou ausências por parte do prestador.</li>
        <li>A atuação da plataforma limita-se à sua disponibilização tecnológica, atuando apenas como facilitadora na mediação de possíveis conflitos entre as partes.</li>
      </ul>
      <h3>4. DEVERES E OBRIGAÇÕES DO CLIENTE</h3>
      <ul>
        <li>O cliente compromete-se a fornecer informações verídicas e precisas em seu cadastro, incluindo os dados necessários para o atendimento, como marca, modelo, cor, placa do veículo e endereço de localização.</li>
        <li>O cliente deve utilizar a plataforma de forma ética e legal, sendo expressamente proibido fraudar ou manipular o sistema de avaliações.</li>
        <li>É terminantemente proibido ao cliente tentar contratar os prestadores diretamente fora da plataforma, prática de bypass, burlando o sistema de intermediação da ClickLav.</li>
      </ul>
      <h3>5. FLUXO DE PAGAMENTOS E CANCELAMENTOS</h3>
      <ul>
        <li>Todos os pagamentos pelos serviços solicitados devem ser realizados obrigatoriamente por meio da plataforma.</li>
        <li>A plataforma processa o pagamento, através de parceiros como a Stripe, retém as taxas de intermediação aplicáveis e repassa os valores devidos ao prestador do serviço.</li>
        <li>O cancelamento de serviços pode ser realizado pelo cliente conforme as políticas exibidas no aplicativo, havendo a possibilidade de cancelamento sem custo desde que efetuado até um determinado prazo, como 4 horas antes do atendimento.</li>
        <li>Caso o cancelamento ocorra fora do prazo estabelecido, poderá haver a cobrança de taxas.</li>
      </ul>
      <h3>6. PRIVACIDADE E PROTEÇÃO DE DADOS (LGPD)</h3>
      <ul>
        <li>A ClickLav realiza o tratamento de dados pessoais em estrita conformidade com a Lei Geral de Proteção de Dados, LGPD, assegurando o uso adequado, a transparência e a segurança das informações do cliente.</li>
        <li>Para viabilizar a prestação do serviço no local desejado, a ClickLav compartilha com o prestador designado estritamente os dados necessários para o atendimento, o que inclui informações do pedido, do veículo e o endereço.</li>
      </ul>
      <h3>7. SUSPENSÃO, ATUALIZAÇÕES E FORO</h3>
      <ul>
        <li>A ClickLav reserva-se o direito de suspender ou bloquear imediatamente o acesso do cliente em casos identificados de fraude, uso indevido da plataforma ou violação de qualquer regra destes termos.</li>
        <li>Estes Termos de Uso poderão ser atualizados a qualquer momento, sendo que o uso contínuo da plataforma pelo cliente implica na aceitação automática e concordância com as atualizações realizadas.</li>
        <li>Fica eleito o foro da comarca de Lauro de Freitas/BA para dirimir e solucionar quaisquer eventuais conflitos decorrentes destes Termos de Uso.</li>
      </ul>
    `,
  },
  clientPrivacy: {
    audience: 'Cliente',
    category: 'Política de Privacidade',
    title: 'Cliente - Políticas de Privacidade',
    description: 'Tratamento de dados pessoais de clientes da plataforma.',
    path: '/politica-de-privacidade/cliente',
    html: `
      <h2>Política de Privacidade - Cliente Clicklav</h2>
      <p><strong>Versão 0103-26</strong></p>
      <h3>1. OBJETIVO E ESCOPO</h3>
      <p>Esta política descreve como a Clicklav coleta, armazena e utiliza dados pessoais de usuários que utilizam o aplicativo para solicitar serviços de estética automotiva. O tratamento é pautado pela transparência e conformidade com a Lei Geral de Proteção de Dados, LGPD.</p>
      <h3>2. DADOS COLETADOS E FINALIDADES</h3>
      <ul>
        <li><strong>Cadastro e Perfil:</strong> nome, e-mail, telefone e CPF para identificação e gestão da conta.</li>
        <li><strong>Dados do Veículo:</strong> marca, modelo, cor e placa para correta identificação durante o atendimento.</li>
        <li><strong>Localização:</strong> endereço informado e coordenadas geográficas para viabilizar o deslocamento do prestador.</li>
        <li><strong>Pagamento:</strong> identificadores de transação processados pela Stripe. A Clicklav não armazena o número completo do seu cartão de crédito.</li>
      </ul>
      <h3>3. COMPARTILHAMENTO DE INFORMAÇÕES</h3>
      <p>Para que o serviço seja executado, compartilhamos com o <strong>Prestador Parceiro</strong> estritamente o necessário: seu nome, localização do veículo, dados do carro e acesso ao chat interno. Seus dados também podem ser compartilhados com provedores de infraestrutura, nuvem, meios de pagamento, Stripe, e serviços de geolocalização.</p>
      <h3>4. SEGURANÇA E RETENÇÃO</h3>
      <ul>
        <li><strong>Proteção:</strong> utilizamos criptografia hash, bcrypt, para senhas e tokens JWT para sessões seguras.</li>
        <li><strong>Prazos:</strong> os dados são mantidos enquanto a conta estiver ativa ou pelo período necessário para cumprir obrigações legais e fiscais.</li>
      </ul>
      <h3>5. SEUS DIREITOS (LGPD)</h3>
      <p>O cliente pode, a qualquer momento, solicitar através dos canais oficiais:</p>
      <ul>
        <li>confirmação e acesso aos dados tratados;</li>
        <li>correção de informações incompletas ou desatualizadas;</li>
        <li>exclusão da conta e de seus dados pessoais, observadas as exceções legais de retenção.</li>
      </ul>
      <h3>6. EXCLUSÃO DE CONTA</h3>
      <p>A plataforma oferece um fluxo direto de exclusão no aplicativo. Ao solicitar a exclusão, a Clicklav remove ou desvincula veículos, endereços, notificações e tokens de sessão, encerrando o tratamento ativo de dados.</p>
      <h3>7. CONTATO E ATUALIZAÇÕES</h3>
      <p>Esta política pode ser atualizada periodicamente. Para dúvidas sobre seus dados, entre em contato com nosso Encarregado de Dados, DPO, pelo e-mail disponibilizado na plataforma.</p>
    `,
  },
  partnerTerms: {
    audience: 'Parceiro',
    category: 'Termos de Uso',
    title: 'Parceiro - Termos de Uso',
    description: 'Condições de uso da plataforma para prestadores parceiros.',
    path: '/termos-de-uso/parceiro',
    html: `
      <h2>Termos e Condições de Uso da Plataforma Clicklav</h2>
      <p><strong>Parceiro</strong></p>
      <h3>1. Aceitação e Natureza da Relação</h3>
      <p>Ao se cadastrar e utilizar a plataforma ClickLav, o PRESTADOR declara concordar integralmente com estes Termos.</p>
      <ul>
        <li><strong>Independência:</strong> o PRESTADOR atua como profissional autônomo, sem qualquer vínculo empregatício com a ClickLav.</li>
        <li><strong>Inexistência de Subordinação:</strong> não há exclusividade, habitualidade ou subordinação. O PRESTADOR pode utilizar outras plataformas simultaneamente.</li>
        <li><strong>Ausência de Metas:</strong> a plataforma não impõe metas de produtividade, controle de jornada ou desempenho mínimo.</li>
      </ul>
      <h3>2. Autonomia Operacional e Algorítmica</h3>
      <p>O PRESTADOR possui total autonomia para gerir sua atividade profissional através do aplicativo:</p>
      <ul>
        <li><strong>Liberdade de Aceite:</strong> o PRESTADOR pode aceitar ou recusar serviços livremente, sem qualquer penalização por recusa.</li>
        <li><strong>Visibilidade Neutra:</strong> a plataforma não reduz a visibilidade do PRESTADOR com base em seu comportamento de aceite ou recusa.</li>
        <li><strong>Execução Técnica:</strong> o PRESTADOR define sua própria forma de execução e o uso de seus equipamentos.</li>
      </ul>
      <h3>3. Onboarding e Verificação de Identidade (KYC)</h3>
      <p>Para habilitar o recebimento de repasses, o PRESTADOR deverá:</p>
      <ul>
        <li><strong>Envio de Documentos:</strong> fornecer CPF, RG, CNH, comprovante de residência e selfie para verificação de identidade e prevenção à fraude.</li>
        <li><strong>Stripe Connect:</strong> aceitar os termos do provedor financeiro, Stripe, para criação da conta de recebimento.</li>
        <li><strong>Veracidade:</strong> garantir a veracidade de todos os dados e referências profissionais enviadas.</li>
      </ul>
      <h3>4. Remuneração e Taxas</h3>
      <ul>
        <li><strong>Referência de Valores:</strong> os valores apresentados no app são referências para o serviço solicitado.</li>
        <li><strong>Taxa de Intermediação:</strong> a ClickLav retém uma taxa sobre cada serviço concluído pela utilização da tecnologia de intermediação.</li>
        <li><strong>Independência Econômica:</strong> o PRESTADOR reconhece que a ClickLav não é sua única fonte de receita.</li>
      </ul>
      <h3>5. Responsabilidade Integral</h3>
      <p>O PRESTADOR é o único e exclusivo responsável por:</p>
      <ul>
        <li><strong>Qualidade e Segurança:</strong> a execução técnica do serviço e a segurança do local de atendimento.</li>
        <li><strong>Danos:</strong> qualquer dano causado ao veículo do cliente ou a terceiros durante ou em razão do serviço.</li>
        <li><strong>Obrigações Fiscais:</strong> emissão de notas fiscais, pagamento de tributos e regularidade perante os órgãos competentes.</li>
      </ul>
      <h3>6. Privacidade e Proteção de Dados (LGPD)</h3>
      <p>O PRESTADOR compromete-se a tratar os dados dos clientes, nome, localização e veículo, recebidos via app exclusivamente para a execução do serviço contratado:</p>
      <ul>
        <li><strong>Vedação de Uso Extra-Plataforma:</strong> é proibido armazenar ou utilizar dados de clientes para fins pessoais ou de marketing fora da ClickLav.</li>
        <li><strong>Confidencialidade:</strong> o PRESTADOR deve manter sigilo sobre as informações acessadas durante os atendimentos.</li>
      </ul>
      <h3>7. Suspensão e Exclusão</h3>
      <p>A ClickLav poderá suspender ou excluir o acesso do PRESTADOR em casos de:</p>
      <ul>
        <li><strong>Fraude ou Má-fé:</strong> manipulação de avaliações, perfis falsos ou uso indevido de dados.</li>
        <li><strong>Violação Legal:</strong> descumprimento da legislação vigente ou destes termos.</li>
        <li><strong>Segurança:</strong> comportamentos que coloquem em risco a integridade dos clientes ou da plataforma.</li>
      </ul>
      <h3>8. Disposições Gerais</h3>
      <ul>
        <li><strong>Práticas Ambientais:</strong> o PRESTADOR incentiva-se a adotar práticas sustentáveis, especialmente a lavagem ecológica.</li>
        <li><strong>Atualizações:</strong> estes termos podem ser atualizados periodicamente, e o uso contínuo do app implica aceitação das novas condições.</li>
        <li><strong>Foro:</strong> fica eleito o foro de Lauro de Freitas/BA para dirimir quaisquer controvérsias.</li>
      </ul>
    `,
  },
  partnerPrivacy: {
    audience: 'Parceiro',
    category: 'Política de Privacidade',
    title: 'Parceiro - Políticas de Privacidade',
    description: 'Tratamento de dados pessoais de prestadores parceiros.',
    path: '/politica-de-privacidade/parceiro',
    html: `
      <h2>Política de Privacidade - Prestador de Serviços</h2>
      <p><strong>Versão 0103-26</strong></p>
      <h3>1. QUEM SOMOS</h3>
      <p>A Clicklav é uma plataforma digital que conecta clientes a prestadores de serviços automotivos sob demanda.</p>
      <p><strong>Controlador dos dados pessoais:</strong></p>
      <ul>
        <li><strong>Razão social:</strong> Clicklav Tecnologia Ltda</li>
        <li><strong>CNPJ:</strong> 38.359.312/0001-69</li>
        <li><strong>Endereço:</strong> Av Santos Dumont, 3092 KM 2,5</li>
        <li><strong>Encarregado (DPO):</strong> Felipe Lopes</li>
        <li><strong>Contato LGPD:</strong> suporte@clicklav.com.br</li>
      </ul>
      <h3>2. QUAIS DADOS COLETAMOS</h3>
      <p>Podemos coletar e tratar:</p>
      <p><strong>Dados cadastrais</strong></p>
      <ul>
        <li>nome, telefone, e-mail, data de nascimento</li>
      </ul>
      <p><strong>Dados de identificação</strong></p>
      <ul>
        <li>CPF, RG, CNH</li>
        <li>CNPJ ou MEI, quando aplicável</li>
      </ul>
      <p><strong>Documentos e imagens</strong></p>
      <ul>
        <li>documentos de identidade</li>
        <li>comprovante de residência</li>
        <li>selfie para verificação de identidade</li>
      </ul>
      <p>A Clicklav <strong>não utiliza reconhecimento facial automatizado</strong>, salvo se expressamente informado no fluxo.</p>
      <p><strong>Dados financeiros</strong></p>
      <ul>
        <li>dados bancários</li>
        <li>informações de pagamento via Stripe Connect</li>
      </ul>
      <p><strong>Dados operacionais</strong></p>
      <ul>
        <li>serviços executados</li>
        <li>histórico de atendimentos</li>
        <li>mensagens com clientes</li>
      </ul>
      <p><strong>Dados de localização</strong></p>
      <ul>
        <li>endereço informado</li>
        <li>localização do dispositivo, com permissão</li>
      </ul>
      <h3>3. COMO COLETAMOS</h3>
      <p>Os dados são coletados:</p>
      <ul>
        <li>diretamente no app</li>
        <li>por upload de documentos</li>
        <li>via integrações, como Stripe</li>
        <li>automaticamente, como localização e push</li>
      </ul>
      <h3>4. PARA QUE USAMOS SEUS DADOS</h3>
      <p>Utilizamos os dados para:</p>
      <ul>
        <li>criar e gerenciar sua conta</li>
        <li>validar sua identidade</li>
        <li>permitir execução dos serviços</li>
        <li>processar pagamentos e repasses</li>
        <li>prevenir fraudes</li>
        <li>cumprir obrigações legais</li>
      </ul>
      <h3>5. BASES LEGAIS</h3>
      <p>Tratamos dados com base em:</p>
      <ul>
        <li>execução de contrato</li>
        <li>obrigação legal ou regulatória</li>
        <li>exercício regular de direitos</li>
        <li>legítimo interesse, segurança e prevenção à fraude</li>
      </ul>
      <h3>6. COMPARTILHAMENTO DE DADOS</h3>
      <p>Seus dados podem ser compartilhados com:</p>
      <ul>
        <li>clientes atendidos, dados mínimos necessários</li>
        <li>provedores de pagamento, como Stripe</li>
        <li>serviços de tecnologia, nuvem e notificações</li>
        <li>autoridades legais, quando exigido</li>
      </ul>
      <p>A Clicklav adota o princípio da <strong>minimização de dados</strong>.</p>
      <h3>7. TRANSFERÊNCIA INTERNACIONAL</h3>
      <p>Alguns fornecedores podem operar fora do Brasil.</p>
      <p>Nesses casos, a Clicklav adota medidas contratuais e técnicas para garantir a proteção dos dados, conforme a LGPD.</p>
      <h3>8. ARMAZENAMENTO E RETENÇÃO</h3>
      <p>Os dados são armazenados pelo tempo necessário para:</p>
      <ul>
        <li>execução dos serviços</li>
        <li>cumprimento de obrigações legais</li>
        <li>prevenção de fraudes</li>
      </ul>
      <p>Exemplos:</p>
      <ul>
        <li>dados financeiros: até 5 anos</li>
        <li>logs operacionais: até 6 meses</li>
        <li>conta ativa: enquanto durar a relação</li>
      </ul>
      <h3>9. SEGURANÇA</h3>
      <p>Adotamos medidas como:</p>
      <ul>
        <li>criptografia de senhas</li>
        <li>autenticação segura</li>
        <li>controle de acesso</li>
        <li>monitoramento de sistemas</li>
      </ul>
      <h3>10. SEUS DIREITOS</h3>
      <p>Você pode solicitar:</p>
      <ul>
        <li>acesso aos dados</li>
        <li>correção</li>
        <li>exclusão</li>
        <li>portabilidade</li>
        <li>revogação de consentimento</li>
      </ul>
      <h3>11. EXCLUSÃO DE CONTA</h3>
      <p>Ao solicitar exclusão:</p>
      <ul>
        <li>seus dados serão eliminados ou anonimizados</li>
        <li>exceto quando necessário por obrigação legal</li>
      </ul>
      <h3>12. CONTATO</h3>
      <p>Para exercer seus direitos: suporte@clicklav.com.br</p>
      <h3>13. ATUALIZAÇÕES</h3>
      <p>Esta política pode ser atualizada a qualquer momento.</p>
    `,
  },
};

export const legalDocumentList = Object.values(legalDocuments);
